var axios = require("axios");

var axiosinstance = axios.create({
  timeout: 20000
});

// Response interceptor
axiosinstance.interceptors.response.use(
  function(response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function(error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if (error.response) {
      if (
        error.response.status == 401 &&
        error.response.data.errorCode == "Y013"
      ) {
        /* Stale Session*/
        window.location.href = "/logout";
      } else if (
        error.response.status == 403 &&
        error.response.data.errorCode == "Y025"
      ) {
        /* Token expired */
        window.location.href = "/logout";
      }
    }
    return Promise.reject(error);
  }
);

module.exports = axiosinstance;
